export const TITLE_OF_DOCUMENTS = {
  frontScanFile: 'Frontal',
  backScanFile: 'Trasera',
};
